import type { ApiConfiguration } from '@goldfishcode/kingmakerdata-api-sdk';
import { Api, createApiClient } from '@goldfishcode/kingmakerdata-api-sdk';
import type { ApiClient } from '@goldfishcode/kingmakerdata-api-sdk/libs/http/client';
import { StorageKeys } from 'src/utils/enum';

import globalVariable from './env';

let apiClient: ApiClient;
let apiIns: Api;

class SessionStorage {
  public async set(key: string, value: string): Promise<void> {
    if (typeof window === 'undefined') return;
    window.localStorage.setItem(key, value);
  }

  public async get(key: string): Promise<string> {
    if (typeof window === 'undefined') return '';

    const value = window.localStorage.getItem(key);
    return value || '';
  }

  public async remove(key: string): Promise<void> {
    if (typeof window === 'undefined') return;
    window.localStorage.removeItem(key);
  }
}

const sessionStorage = new SessionStorage();
const config: ApiConfiguration = {
  baseUrl: globalVariable.API_URL,
  authSessionKey: StorageKeys.SESSION_KEY,
  session: sessionStorage,
  socketUrl: globalVariable.SOCKET_URL,
  timeout: 1000 * 60 * 10, // 10min
  application: 'kingmaker-web',
};

const initSDKService = (): void => {
  apiClient = createApiClient(config);
  apiIns = new Api(apiClient);
};

export { apiClient, apiIns, initSDKService };
